import React from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import Collect from "../../invoices/unpaid_invoices/components/Collect";
import EditDelete from "../../../components/EditDelete";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import AdvanceFilter from "./AdvanceFilter";
import useReport from "../../../hooks/useReports";
import { getTimeStamp } from "../../../utils/common";
import useMainContentDimensions from "../../../utils/mainContentDimensions";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Reports</Typography>
      <Typography>Hold Reports</Typography>
    </Breadcrumbs>
  );
};

const CustomDataGrid = (props) => {
  const { isLoadingDownload, downloadFileType } = useReport();
  const { width: mainContentWidth } = useMainContentDimensions();

  const { height, width } = useWindowDimensions();
  const navigate = useNavigate();
  const {
    trans,
    data,
    rowCount,
    paging,
    payload,
    setPayload,
    setFilterResetFunc,
    onPaginationModelChange,
    isLoading,
    id,
    handleSortModelChange,
    sortModel,
    downloadFile,
    openDownloadDialog,
    refreshPage,
    filterFormData,
    setFilterFormData,
  } = props;
  console.log(rowCount, "loading child component");
  const { openDialog } = useDialog();

  const collectClick = (id) => {
    return openDialog(
      "collect",
      "Collect",
      <Collect key={getTimeStamp()} radUsersHoldId={id} refreshPage={refreshPage} />,
    );
  };

  const columns = [
    {
      field: "customerName",
      headerName: "Customer Name",
      width: 300,
    },

    {
      field: "startDate",
      headerName: "Start Date",
      width: 200,
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 200,
    },
    {
      field: "createdBy",
      headerName: "created By",
      width: 130,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
        filterFormData={filterFormData}
        setFilterFormData={setFilterFormData}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            downloadFile={downloadFile}
            openDownloadDialog={openDownloadDialog}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {trans("hold_reports")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={data || []}
            rowCount={rowCount}
            getRowId={(row) => row.radUsersHoldId}
            loading={isLoading}
            paginationMode="server"
            onPaginationModelChange={onPaginationModelChange}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": { backgroundColor: "#f9f9f9" },
              "& .MuiDataGrid-row.odd-row": { backgroundColor: "#ffffff" },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
CustomDataGrid.propTypes = {
  trans: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  rowCount: PropTypes.number.isRequired,
  paging: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  handleSortModelChange: PropTypes.func.isRequired,
  sortModel: PropTypes.array.isRequired,
};
export default CustomDataGrid;
